"use strict";

exports.__esModule = true;
exports.default = void 0;
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var _default = exports.default = listCacheClear;